<template>
  <footer class="guided-mode-navigation">
    <button type="button" class="guided-mode-navigation__button" :aria-label="$t('app.assessment_mode.guided.navigation.previous')" @click="$emit('previous')">
      <v-icon class="guided-mode-navigation__icon guided-mode-navigation__icon--previous" size="28">{{ previousIcon }}</v-icon>
    </button>
    <div class="guided-mode-navigation__progress" :aria-label="$t('app.assessment_mode.guided.navigation.progress')">
      <span v-for="(segment, index) in progressSegments" :key="index" class="guided-mode-navigation__progress-track">
        <span class="guided-mode-navigation__progress-fill" :style="{ width: `${segment}%` }"></span>
      </span>
    </div>
    <button type="button" class="guided-mode-navigation__button guided-mode-navigation__button--next" :aria-label="$t('app.assessment_mode.guided.navigation.next')"
            data-analytics-skip :disabled="nextDisabled" @click="$emit('next')">
      <v-icon class="guided-mode-navigation__icon guided-mode-navigation__icon--next" size="28">{{ nextIcon }}</v-icon>
    </button>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default defineComponent({
  name: 'GuidedModeNavigation',
  props: {
    nextDisabled: { type: Boolean, default: false },
    progressSegments: { type: Array as PropType<number[]>, default: () => [0] },
  },
  computed: {
    rtl(): boolean {
      return Boolean(this.$vuetify?.rtl)
    },
    previousIcon(): string {
      return this.rtl ? mdiChevronRight : mdiChevronLeft
    },
    nextIcon(): string {
      return this.rtl ? mdiChevronLeft : mdiChevronRight
    },
  },
})
</script>
